"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => {
    const value = [];
    if (token.minPx)
        value.push(`(min-width: ${token.minPx}px)`);
    if (token.maxPx)
        value.push(`(max-width: ${token.maxPx}px)`);
    const result = [
        {
            name,
            tokenType: "viewport",
            type: "media",
            value: value.join(" and "),
        },
    ];
    if (token.minPx) {
        result.push({
            name: `${name}-min`,
            tokenType: "viewport",
            type: "variable",
            value: token.minPx.toString(),
        });
    }
    return result;
};
exports.default = transformToken;
